
 



 
 import {fs} from "Config/FsConfig";
 
    import AuditLogSearchParameter from 'Modules/Core/Scripts/AppServiceContract/AuditLogSearchParameter';

    import AuditLogSearchData from 'Modules/Core/Scripts/AppServiceContract/AuditLogSearchData';

    import AuditLogCategoryData01 from 'Modules/Core/Scripts/AppServiceContract/AuditLogCategoryData01';

    import AuditLogSearchCriteria from 'Modules/Core/Scripts/AuditLogSearchCriteria';


    //module AuditLogSearchAppService {
    class AuditLogSearchAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/AuditLogSearchAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/AuditLogSearchAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/AuditLogSearchAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(parameter: AuditLogSearchParameter): JQuery.jqXHR<AuditLogSearchData[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindAuditLogCategoryDropdown = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/AuditLogSearchAppService/FindAuditLogCategoryDropdown`;
    public RouteFindAuditLogCategoryDropdown() : string {
        return this.ControllerUrl + "/"+"FindAuditLogCategoryDropdown";
    }
    public FindAuditLogCategoryDropdown(): JQuery.jqXHR<AuditLogCategoryData01[]> {
        return $.ajax({
                url: this.RouteFindAuditLogCategoryDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/AuditLogSearchAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(criteria: AuditLogSearchCriteria): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default AuditLogSearchAppService;



